<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-card>
      <v-card-title class="headline"
        >ノート設定 <v-spacer /> <v-btn text @click="onClose">戻る</v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            ><span class="subtitle-1 font-weight-bold">
              画像のダウンロード動作</span
            ><br />
            <span class="caption red--text"
              >※ 再読み込み後から反映されます。</span
            >

            <v-radio-group
              v-model="imageDownloadMode"
              class="ml-5"
              @change="onImageDownloadMode"
            >
              <v-radio
                v-for="entry in settings.imageDownloadModeList"
                :key="entry.mode"
                :value="entry.mode"
                :label="entry.label"
              ></v-radio>
            </v-radio-group>
            <div class="caption ml-5 mt-n3">
              <v-icon small class="mt-n1 mr-2">mdi-lightbulb-on-outline</v-icon
              >{{ imageDownloadModeHint }}<br />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ><span class="subtitle-1 font-weight-bold"> 関連ノート</span><br />
            <span class="caption red--text"
              >※ 再読み込み後から反映されます。</span
            >
            <v-switch
              v-model="relatedNoteEnabled"
              label="関連ノートの読み込みと表示"
              class="ml-5"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ><span class="subtitle-1 font-weight-bold">フォントサイズ</span
            ><span class="mx-5">{{ Number(fontSize).toFixed(1) }}pt</span>
            <v-btn icon @click="onChangeFontSize(false)">
              <v-icon class="mt-n1">mdi-format-font-size-decrease</v-icon>
            </v-btn>
            <v-btn icon @click="onChangeFontSize(true)">
              <v-icon class="mt-n1">mdi-format-font-size-increase</v-icon>
            </v-btn>
            <!-- <span class="subtitle-2 ml-5">サンプル</span> -->
            <div :style="contentStyle" class="mx-5 mt-3">
              （サンプル）Harvester
              は個人開発者によって開発・運営されています。Evernote社とは無関係です。
              以下の機種/プラットフォーム/ブラウザで動作確認がとれています。
            </div>
          </v-col></v-row
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import settings from '@/services/SettingsService'

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      fontSize: 0,
      imageDownloadMode: '0',
      imageDownloadModeHint: '',
      contentStyle: {
        lineHeight: '1.8em',
        fontSize: '14pt',
        borderRadius: '5px',
        border: 'solid 1px grey',
        padding: '0.5em'
      }
    }
  },
  computed: {
    settings: () => settings,
    relatedNoteEnabled: {
      get: () => settings.relatedNoteEnabled,
      set: newValue => {
        settings.relatedNoteEnabled = newValue
      }
    }
    // relatedNoteLengthItems: () => [...Array(10).keys()].map(i => ++i),
    // relatedNoteLength: {
    //   get: () => settings.relatedNoteLength,
    //   set: newValue => {
    //     settings.relatedNoteLength = newValue
    //   }
    // }
  },
  mounted() {
    this.contentStyle.fontSize = `${settings.fontSize}pt`
    this.fontSize = settings.fontSize
    // console.log(settings.fontSize)
    this.imageDownloadMode = settings.imageDownloadMode
    this.imageDownloadModeHint = settings.imageDownloadModeHint
  },
  methods: {
    open() {
      this.dialog = true
      return new Promise(resolve => (this.resolve = resolve))
    },

    onClose() {
      this.dialog = false
      this.resolve(true)
    },
    onChangeFontSize(increase) {
      const s = settings.fontSize + (increase ? 0.5 : -0.5)
      settings.fontSize = s
      this.fontSize = s
      this.contentStyle.fontSize = `${settings.fontSize}pt`
    },
    onImageDownloadMode(value) {
      settings.imageDownloadMode = value
      this.imageDownloadModeHint = settings.imageDownloadModeHint
    }
  }
}
</script>

<style scoped></style>
